import { memo } from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

export const Hr = memo(
  ({
    style,
    color = '#ddd',
    height = StyleSheet.hairlineWidth,
  }: {
    style?: StyleProp<ViewStyle>;
    color?: string;
    height?: number;
  }) => {
    return (
      <View
        style={[
          {
            backgroundColor: color,
            height,
          },
          style,
        ]}
      />
    );
  },
);
